// Build-time flags: Expo inlines EXPO_PUBLIC_* values when bundling, so keep
// the direct `process.env.EXPO_PUBLIC_…` reference.

// In-studio multi-camera ("add camera" → CamStrip + the mixer on
// 37.27.56.243). It never worked in production (Oct 2026 review): every
// camera slot was refused at the ingest, and pressing the button switched the
// customer's own stream to a camera slot that never went live. Off until the
// rebuild; the code stays for that.
export const MULTICAM_ENABLED = process.env.EXPO_PUBLIC_MULTICAM_ENABLED === "true";
